<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visible"
    width="70%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="viewMode ? {} : rules"
      label-width="110px"
      :disabled="viewMode"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            label="商机名称"
            :prop="!viewMode ? 'opportunityName' : ''"
          >
            <el-input
              v-model="form.opportunityName"
              placeholder="请输入商机名称"
              style="width: 100%"
            />
          </el-form-item>
          <!-- 标签改为 商机来源，开启可搜索、手动创建 -->
          <el-form-item label="商机来源" :prop="!viewMode ? 'source' : ''">
            <el-select
              v-model="form.source"
              placeholder="请选择或手动输入商机来源"
              style="width: 100%"
              filterable
              allow-create
              :disabled="!sourceOptions.length"
            >
              <el-option
                v-for="item in sourceOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.description"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="需求面积"
            :prop="!viewMode ? 'expectedValue' : ''"
          >
            <el-input
              v-model.number="form.expectedValue"
              placeholder="请输入需求面积"
              style="width: 100%"
              type="number"
              min="0.01"
              step="0.01"
            />
          </el-form-item>
          <el-form-item
            label="预计成交日期"
            :prop="!viewMode ? 'expectedDealDate' : ''"
          >
            <el-date-picker
              v-model="form.expectedDealDate"
              type="date"
              placeholder="年/月/日"
              style="width: 100%"
              :disabled-date="disabledPastDate"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="商机类型"
            :prop="!viewMode ? 'opportunityType' : ''"
          >
            <el-select
              v-model="form.opportunityType"
              placeholder="请选择商机类型"
              style="width: 100%"
              :disabled="!opportunityTypeOptions.length"
            >
              <el-option
                v-for="item in opportunityTypeOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="客户名称"
            :prop="!viewMode ? 'customerName' : ''"
          >
            <el-input
              v-model="form.customerName"
              placeholder="请选择或输入客户名称"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="状态" :prop="!viewMode ? 'status' : ''">
            <el-select
              v-model="form.status"
              placeholder="请选择状态"
              style="width: 100%"
              :disabled="!statusOptions.length"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.statusCd"
                :label="item.description"
                :value="item.statusCd"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="负责人"
            :prop="!viewMode ? 'responsiblePerson' : ''"
          >
            <el-select
              v-model="form.responsiblePerson"
              placeholder="请选择负责人"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="user in userOptions"
                :key="user.name"
                :label="user.name"
                :value="user.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="行业类型"
            :prop="!viewMode ? 'industryType' : ''"
          >
            <el-input
              v-model="form.industryType"
              placeholder="请输入行业类型"
              style="width: 100%"
            />
          </el-form-item>
          <!-- 房源多选 -->
          <el-form-item label="房源" :prop="!viewMode ? 'roomId' : ''">
            <el-select
              v-model="form.roomId"
              placeholder="请选择房源"
              style="width: 100%"
              filterable
              multiple
            >
              <el-option
                v-for="item in roomOptions"
                :key="item.roomId"
                :label="item.roomName"
                :value="item.roomId"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="商机描述" :prop="!viewMode ? 'description' : ''">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="4"
          placeholder="请输入商机描述"
          maxlength="500"
          style="width: 100%"
        />
      </el-form-item>

      <el-form-item label="附件" :prop="!viewMode ? 'attachments' : ''">
        <div v-if="viewMode" class="view-attachment">
          <el-link
            v-if="form.attachments"
            :href="form.attachments"
            target="_blank"
            icon="el-icon-download"
          >
            {{ getFileName(form.attachments) }}
          </el-link>
          <span v-else> 无附件 </span>
        </div>

        <div v-else class="edit-attachment">
          <el-upload
            class="upload-demo"
            drag
            action="/callComponent/upload/uploadFile/uploadImage"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
            :limit="1"
            name="uploadFile"
            :data="uploadExtraParams"
            :file-list="fileList"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :auto-upload="true"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持 PDF, Word, Excel, PPT (单个文件最大 10MB)
            </div>
          </el-upload>
          <div
            v-if="form.originalAttachments && fileList.length === 0"
            class="original-attachment mt-2"
          >
            <span class="label"> 原附件：</span>
            <el-link
              :href="form.originalAttachments"
              target="_blank"
              icon="el-icon-download"
              class="ml-1"
            >
              {{ getFileName(form.originalAttachments) }}
            </el-link>
          </div>
        </div>
      </el-form-item>

      <el-row
        v-if="viewMode && businessOpportunityLogDTOList.length > 0"
        :gutter="20"
        class="mt-4"
      >
        <el-col :span="24">
          <div class="history-header">
            <h4 class="history-title">变更历史</h4>
            <el-button
              v-if="businessOpportunityLogDTOList.length > 3"
              type="text"
              size="small"
              @click="isCollapsed = !isCollapsed"
              class="toggle-btn"
            >
              {{ isCollapsed ? "展开全部" : "收起" }}
              <i
                :class="isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
              ></i>
            </el-button>
          </div>

          <el-timeline class="custom-timeline">
            <el-timeline-item
              v-for="(log, index) in filteredLogs"
              :key="log.id || index"
              :timestamp="formatTimestamp(log.updateTime || log.createTime)"
              placement="top"
              class="timeline-item"
            >
              <el-card class="log-card">
                <div class="log-header">
                  <span class="log-operator">
                    <strong>修改时间:</strong>
                    {{ formatDate(log.createTime) || "无日期" }}
                  </span>
                  <el-button
                    type="text"
                    size="mini"
                    class="detail-toggle"
                    @click="log.isExpanded = !log.isExpanded"
                    :disabled="false"
                  >
                    {{ log.isExpanded ? "隐藏详情" : "显示详情" }}
                  </el-button>
                </div>

                <transition name="fade">
                  <div v-if="log.isExpanded" class="log-details">
                    <div class="log-row">
                      <span class="log-label">状态:</span>
                      <span class="log-value">{{
                        getStatusLabel(log.status)
                      }}</span>
                    </div>
                    <div class="log-row">
                      <span class="log-label">谈判进度:</span>
                      <span class="log-value">{{
                        getNegotiationProgressLabel(log.negotiationProgress)
                      }}</span>
                    </div>
                    <div class="log-row">
                      <span class="log-label">商机名称:</span>
                      <span class="log-value">{{
                        log.opportunityName || "-"
                      }}</span>
                    </div>
                    <div class="log-row">
                      <span class="log-label">客户名称:</span>
                      <span class="log-value">{{
                        log.customerName || "-"
                      }}</span>
                    </div>
                    <div class="log-row">
                      <span class="log-label">需求面积:</span>
                      <span class="log-value">{{
                        log.expectedValue || "-"
                      }}</span>
                    </div>
                    <div class="log-row">
                      <span class="log-label">商机描述:</span>
                      <span class="log-value">{{
                        log.description || "-"
                      }}</span>
                    </div>
                  </div>
                </transition>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关闭</el-button>
      <el-button v-if="!viewMode" type="primary" @click="submitForm">
        保存
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  getBusinessOpportunityById,
  updateBusinessOpportunity,
} from "@/api/businessOpportunity/businessOpportunityApi";
import { getDict } from "@/api/community/communityApi";

export default {
  name: "BusinessOpportunityEditView",
  props: {
    viewMode: {
      type: Boolean,
      default: false,
    },
    sourceOptions: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
    userOptions: {
      type: Array,
      default: () => [],
    },
    roomOptions: {
      type: Array,
      default: () => [],
    },
    opportunityTypeOptions: {
      type: Array,
      default: () => [],
    },
    negotiationProgressOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploadExtraParams: {
        communityId: this.communityId,
      },
      communityId: -1,
      visible: false,
      form: {
        id: "",
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        expectedDealDate: "",
        description: "",
        attachments: "",
        originalAttachments: "",
        industryType: "",
        opportunityType: "",
        negotiationProgress: "",
        roomId: [],
      },
      fileList: [],
      businessOpportunityLogDTOList: [],
      isCollapsed: true,
      rules: {
        opportunityName: [
          { required: true, message: "请输入商机名称", trigger: "blur" },
          { max: 100, message: "商机名称最多100个字符", trigger: "blur" },
        ],
        customerName: [
          { required: true, message: "请选择或输入客户名称", trigger: "blur" },
        ],
        source: [
          {
            required: true,
            message: "请选择或输入商机来源",
            trigger: "change",
          },
        ],
        status: [
          { required: true, message: "请选择商机状态", trigger: "change" },
        ],
        expectedValue: [
          { required: true, message: "请输入需求面积", trigger: "blur" },
        ],
        description: [
          { max: 500, message: "商机描述最多500个字符", trigger: "blur" },
        ],
        industryType: [
          { required: true, message: "请输入行业类型", trigger: "blur" },
          { max: 50, message: "行业类型最多50个字符", trigger: "blur" },
        ],
        opportunityType: [
          { required: true, message: "请选择商机类型", trigger: "change" },
        ],
        negotiationProgress: [
          { required: true, message: "请选择谈判进度", trigger: "change" },
        ],
        roomId: [{ required: true, message: "请选择房源", trigger: "change" }],
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.viewMode ? "查看商机" : "编辑商机";
    },
    filteredLogs() {
      if (this.isCollapsed && this.businessOpportunityLogDTOList.length > 3) {
        return this.businessOpportunityLogDTOList.slice(0, 3);
      }
      return this.businessOpportunityLogDTOList;
    },
  },
  methods: {
    async open(opportunityParam) {
      this.visible = true;
      this.initForm();
      try {
        await Promise.all([
          this.loadDictData(),
          this.loadBusinessOpportunityDetail(opportunityParam),
        ]);
      } catch (error) {
        this.$message.error("初始化失败");
        this.visible = false;
      }
    },

    initForm() {
      this.form = {
        id: "",
        opportunityName: "",
        customerName: "",
        source: "",
        status: "",
        expectedValue: null,
        responsiblePerson: "",
        expectedDealDate: "",
        description: "",
        attachments: "",
        originalAttachments: "",
        industryType: "",
        opportunityType: "",
        negotiationProgress: "",
        roomId: [],
      };
      this.fileList = [];
      this.businessOpportunityLogDTOList = [];
      this.isCollapsed = true;
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },

    async loadDictData() {
      const isNeedLoad =
        !this.sourceOptions.length ||
        !this.statusOptions.length ||
        !this.opportunityTypeOptions.length ||
        !this.negotiationProgressOptions.length;
      if (!isNeedLoad) return;

      try {
        const [sourceDict, statusDict, opportunityDict, negotiationDict] =
          await Promise.all([
            getDict("business_opportunity_source", "audit"),
            getDict("business_opportunity_status", "audit"),
            getDict("opportunity_type", "audit"),
            getDict("negotiation_progress", "audit"),
          ]);

        this.sourceOptions = this.sourceOptions.length
          ? this.sourceOptions
          : sourceDict.filter((item) => item.statusCd);
        this.statusOptions = this.statusOptions.length
          ? this.statusOptions
          : statusDict.filter((item) => item.statusCd);
        this.opportunityTypeOptions = this.opportunityTypeOptions.length
          ? this.opportunityTypeOptions
          : opportunityDict.filter((item) => item.statusCd);
        this.negotiationProgressOptions = this.negotiationProgressOptions.length
          ? this.negotiationProgressOptions
          : negotiationDict.filter((item) => item.statusCd);
      } catch (error) {
        console.error("字典加载失败:", error);
        throw error;
      }
    },

    async loadBusinessOpportunityDetail(opportunityParam) {
      try {
        const opportunityData = opportunityParam.id
          ? (await getBusinessOpportunityById({ id: opportunityParam.id })).data
          : opportunityParam;

        const logList = Array.isArray(
          opportunityData.businessOpportunityLogDTOList,
        )
          ? opportunityData.businessOpportunityLogDTOList
          : [];

        this.businessOpportunityLogDTOList = [...logList]
          .sort(
            (a, b) =>
              new Date(b.update_time || b.create_time) -
              new Date(a.update_time || a.create_time),
          )
          .map((log, index) => ({
            ...log,
            isExpanded: index === 0,
          }));

        const mainData = { ...opportunityData };
        delete mainData.businessOpportunityLogDTOList;

        this.$nextTick(() => {
          this.form.id = mainData.id || "";
          this.form.opportunityName = mainData.opportunityName || "";
          this.form.customerName = mainData.customerName || "";
          // 商机来源：直接赋值文本（适配手动输入+下拉选择）
          this.form.source = mainData.source || "";
          this.form.status = mainData.status || "";
          this.form.expectedValue = mainData.expectedValue
            ? Number(mainData.expectedValue)
            : null;
          this.form.responsiblePerson = mainData.responsiblePerson || "";
          this.form.expectedDealDate = mainData.expectedDealDate
            ? mainData.expectedDealDate.split(" ")[0]
            : "";
          this.form.description = mainData.description || "";
          this.form.attachments = mainData.attachments || "";
          this.form.originalAttachments = mainData.attachments || "";
          this.form.industryType = mainData.industryType || "";
          this.form.opportunityType = mainData.opportunityType || "";
          this.form.negotiationProgress = mainData.negotiationProgress || "";

          // 房源字符串转数组
          if (mainData.roomId && typeof mainData.roomId === "string") {
            this.form.roomId = mainData.roomId
              .split(",")
              .filter((id) => id && id.trim() !== "");
          } else {
            this.form.roomId = [];
          }
        });
      } catch (error) {
        console.error("商机详情加载失败:", error);
        throw error;
      }
    },

    getFileName(url) {
      if (!url) return "";
      return url.substring(url.lastIndexOf("/") + 1);
    },

    handleUploadSuccess(response, file, fileList) {
      if (response && response.url) {
        file.url = response.url;
        this.fileList = fileList;
        this.$message.success("文件上传成功");
      } else {
        this.$message.error("文件上传失败");
      }
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$message.info("文件删除成功");
    },

    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;

        try {
          const finalAttachmentUrl =
            this.fileList.length > 0
              ? this.fileList[0].url
              : this.form.originalAttachments;
          this.form.attachments = finalAttachmentUrl || "";

          // 房源数组转回逗号字符串
          if (Array.isArray(this.form.roomId)) {
            this.form.roomId = this.form.roomId.join(",");
          }

          const response = await updateBusinessOpportunity(this.form);
          if (response.code === 0) {
            this.$message.success("编辑成功");
            this.visible = false;
            this.$emit("refreshData");
          } else {
            this.$message.error(response.msg || "编辑失败");
          }
        } catch (error) {
          this.$message.error("操作失败");
          console.error("更新商机失败:", error);
        }
      });
    },

    disabledPastDate(date) {
      return date && date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    handleClose() {
      this.visible = false;
      this.initForm();
    },

    getStatusLabel(statusCd) {
      const item = this.statusOptions.find((opt) => opt.statusCd === statusCd);
      return item ? item.description : statusCd || "—";
    },

    getNegotiationProgressLabel(progressCd) {
      const item = this.negotiationProgressOptions.find(
        (opt) => opt.statusCd === progressCd,
      );
      return item ? item.description : progressCd || "—";
    },

    formatTimestamp(time) {
      if (!time) return "—";
      const date = new Date(time);
      if (isNaN(date.getTime())) return String(time);
      const pad = (n) => n.toString().padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate(),
      )} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds(),
      )}`;
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) {
        return dateStr.length >= 10 ? dateStr.substring(0, 10) : dateStr;
      }
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style scoped lang="scss">
.view-attachment {
  margin-top: 4px;
  color: #409eff;
  font-size: 14px;
}

.edit-attachment {
  .original-attachment {
    color: #606266;
    font-size: 13px;
    .label {
      margin-right: 8px;
    }
  }
}

::v-deep .el-upload__tip {
  margin-top: 6px;
  font-size: 13px;
  color: #606266;
}

::v-deep .el-form-item__content {
  line-height: 1.2;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px 24px 24px;
  margin-top: 12px;
}

.history-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;

  .history-title {
    font-size: 16px;
    color: #303133;
    margin: 0;
    font-weight: 500;
  }

  .toggle-btn {
    color: #409eff;
    padding: 0;
    height: auto;
  }
}

.custom-timeline {
  padding-left: 20px;

  .timeline-item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .el-timeline-item__timestamp {
      color: #606266;
      font-size: 12px;
      margin-bottom: 8px;
      font-weight: 500;
      display: none;
      border: none;
    }
    .el-timeline-item__node {
      width: 12px;
      height: 12px;
      background-color: #409eff;
      border-color: #409eff;
    }
    .el-timeline-item__line {
      left: 5px;
      width: 2px;
      background-color: #e6e6e6;
      display: none;
      border: none;
    }
  }
}

.log-card {
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  border: 1px solid #ebeef5;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
  border-bottom: 1px dashed #f0f0f0;
  .log-operator {
    color: #303133;
    font-size: 14px;
  }
  .detail-toggle {
    color: #409eff;
    padding: 0;
    height: auto;
    font-size: 12px;
  }
}

.log-details {
  margin-top: 12px;
  .log-row {
    display: flex;
    margin-bottom: 8px;
    font-size: 13px;
    &:last-child {
      margin-bottom: 0;
    }
    .log-label {
      color: #606266;
      width: 120px;
      flex-shrink: 0;
      font-weight: 500;
    }
    .log-value {
      color: #303133;
      flex-grow: 1;
      word-break: break-all;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.log-item p {
  margin: 4px 0;
  font-size: 13px;
}
</style>
